module.exports = __webpack_public_path__ + "media/site/images/call-to-action/call-to-action-tracking-162519cdd6da84f5aa73768c900fb60a.png";